import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '@/services/api';

interface PreferencesState {
  timezone: string;
  isLoading: boolean;
  isSynced: boolean;
  setTimezone: (timezone: string) => void;
  fetchPreferences: () => Promise<void>;
  updateTimezone: (timezone: string) => Promise<void>;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set, get) => ({
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
      isLoading: false,
      isSynced: false,

      setTimezone: (timezone: string) => set({ timezone }),

      fetchPreferences: async () => {
        set({ isLoading: true });
        try {
          const prefs = await api.getUserPreferences();
          set({ timezone: prefs.timezone, isSynced: true, isLoading: false });
        } catch {
          // If fetch fails, use local timezone as fallback
          set({ isLoading: false });
        }
      },

      updateTimezone: async (timezone: string) => {
        const previousTimezone = get().timezone;
        set({ timezone, isLoading: true });
        try {
          await api.updateUserPreferences({ timezone });
          set({ isSynced: true, isLoading: false });
        } catch {
          // Revert on failure
          set({ timezone: previousTimezone, isLoading: false });
        }
      },
    }),
    {
      name: 'statsmatic-preferences',
      partialize: (state) => ({ timezone: state.timezone }),
    }
  )
);

export default usePreferencesStore;
